import { acpBankTransfersStates } from './states';

export default (appModule) => {
  appModule.config(acpBankTransfersStates);
};
